import { render } from "./TextboxElement.vue?vue&type=template&id=5d081f62&scoped=true"
import script from "./TextboxElement.vue?vue&type=script&lang=js"
export * from "./TextboxElement.vue?vue&type=script&lang=js"

import "./TextboxElement.vue?vue&type=style&index=0&id=5d081f62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d081f62"]])

export default __exports__